import React from "react";

type SummaryCardProps = {
    title: React.ReactNode;
    children: React.ReactNode;
    className?: string;
};

export const SummaryCard: React.FC<SummaryCardProps> = ({ title, children, className }) => {
    return (
        <div className={"card mb-3 " + (className || "")}> 
            <div className="card-header d-flex align-items-center">
                <h3 className="card-title m-0 d-flex align-items-center">{title}</h3>
            </div>
            <div className="card-body border rounded-3 shadow-sm p-3">
                {children}
            </div>
        </div>
    );
};

export default SummaryCard;



